import { render, staticRenderFns } from "./CurrencyConversionLogs.vue?vue&type=template&id=4506f856"
import script from "./CurrencyConversionLogs.vue?vue&type=script&lang=js"
export * from "./CurrencyConversionLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports